'use strict';

function _interopDefault (ex) { return (ex && (typeof ex === 'object') && 'default' in ex) ? ex['default'] : ex; }

var React = require('react');
var React__default = _interopDefault(React);
var reactRouterDom = require('react-router-dom');
var ArrowBackIcon = _interopDefault(require('@material-ui/icons/ArrowBack'));
var BlueTextButton = require('../BlueTextButton/BlueTextButton.js');

var BackButton = function (props) {
    var title = props.title, url = props.url;
    var history = reactRouterDom.useHistory();
    var handleClick = url ? function () { return history.push(url); } : function () { return history.goBack(); };
    return React__default.createElement(BlueTextButton, { title: title, onClick: handleClick, icon: React__default.createElement(ArrowBackIcon, null) });
};

module.exports = BackButton;
